import { UniqueIdentifier } from "@dnd-kit/core";
import { BasicFilter, CompositeFilter } from "../types";

// // // //

export enum EditorFilterMessageTypes {
    missingField = "missingField",
    missingOperator = "missingOperator",
    missingValue = "missingValue",
    redundantComposite = "redundantComposite",
    redundantAndClause = "redundantAndClause",
    redundantOrClause = "redundantOrClause",
    redundantParentComposite = "redundantParentComposite",
    redundantCongruentParentComposite = "redundantCongruentParentComposite",
    emptyComposite = "emptyComposite",
    andOperatorContainsDuplicateFields = "andOperatorContainsDuplicateFields",
    duplicateBasicFilterInsideAndClause = "duplicateBasicFilterInsideAndClause",
    groupContainsIdenticalFields = "groupContainsIdenticalFields",
    identicaBasicFilterInsideGroup = "identicaBasicFilterInsideGroup",
}

export interface EditorFilterMessage {
    type: EditorFilterMessageTypes;
    variant: "info" | "warning" | "error";
}

/**
 * EditorFilter
 * Represents a single filter (basic or composite) in the context of the FilterEditor component
 * Includes additional metadata to separate the concerns of API filtering from the UI layer to build API filters
 * @property {UniqueIdentifier} id - The unique identifier of the filter
 * @property {BasicFilter | CompositeFilter} state - The state of the filter, which can be either a BasicFilter or a CompositeFilter
 * @property {EditorFilter[]} nested - An array of nested EditorFilter instances
 * @property {boolean} enabled - Whether or not the EditorFilter should be applied in the query
 * @property {Array<EditorFilterMessage>} messages - Array of EditorFilterMessage items to encapsulate user feedback
 */
export interface EditorFilter {
    id: UniqueIdentifier;
    state: BasicFilter | CompositeFilter;
    nested: EditorFilter[];
    enabled: boolean;
    messages: EditorFilterMessage[];
}
